import { msg } from '@lingui/core/macro';

import { defineFilters } from '@/shared/filters/define-filters';

// O único filtro da lista (`FilterProvider` de `TenantPermissionResourceListContainer.tsx:78-80` e
// `components/DataTableFilters/TenantPermissionResourceFilters/*`): "Correspondente" → `searchString`.
// Aplicar de novo troca o valor (não é `multiple`). Arquivo leve: o `shape` entra no `validateSearch`.
export const tenantPermissionResourceFilters = defineFilters([
  {
    key: 'searchString',
    type: 'text',
    label: msg`Correspondente`,
    placeholder: msg`Filtrar pelo nome do correspondente`,
    pinned: true,
    max: 100,
  },
]);
